<script setup>
import { ref, computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  subMenuPosition: {
    type: String,
    default: 'right',
    validator: value => {
      return ['right', 'left', 'bottom'].includes(value);
    },
  },
});

const emit = defineEmits(['update:modelValue']);

const isOpen = ref(false);

const labelValue = computed(() => props.label);

const toggleMenu = () => {
  isOpen.value = !isOpen.value;
};

const handleSelect = value => {
  emit('update:modelValue', value);
  isOpen.value = false;
};
</script>

<template>
  <div
    v-on-clickaway="() => (isOpen = false)"
    class="relative flex w-full flex-col gap-1 md:w-fit"
  >
    <Button
      icon="i-lucide-chevron-down"
      size="sm"
      trailing-icon
      color="slate"
      variant="faded"
      class="!w-full max-w-full justify-between md:!w-fit md:max-w-40"
      :class="{ 'dark:!bg-n-alpha-2 !bg-n-slate-9/20': isOpen }"
      :label="labelValue"
      @click="toggleMenu"
    />
    <div
      v-if="isOpen"
      class="absolute z-40 flex max-w-[calc(100vw-2rem)] select-none flex-col gap-1 rounded-lg border border-n-weak bg-n-alpha-3 p-1 shadow-lg backdrop-blur-[100px] md:max-w-64 dark:border-n-strong/50"
      :class="{
        'top-full mt-1 ltr:right-0 rtl:left-0 md:top-0 md:mt-0 md:ltr:left-full md:rtl:right-full md:ltr:right-auto md:rtl:left-auto md:ltr:ml-1 md:rtl:mr-1':
          subMenuPosition === 'right',
        'top-full mt-1 ltr:right-0 rtl:left-0 md:top-0 md:mt-0 md:ltr:right-full md:rtl:left-full md:ltr:left-auto md:rtl:right-auto md:ltr:mr-1 md:rtl:ml-1':
          subMenuPosition === 'left',
        'top-full mt-1 ltr:right-0 rtl:left-0': subMenuPosition === 'bottom',
      }"
    >
      <Button
        v-for="option in options"
        :key="option.value"
        :label="option.label"
        :icon="option.value === modelValue ? 'i-lucide-check' : ''"
        size="sm"
        variant="ghost"
        color="slate"
        trailing-icon
        class="!justify-end !px-2.5 !h-7"
        :class="{ '!bg-n-alpha-2': option.value === modelValue }"
        @click="handleSelect(option.value)"
      />
    </div>
  </div>
</template>
